// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"RestaurantSearch_searchInput__Eu_zG","searchBoxContainer":"RestaurantSearch_searchBoxContainer__BjRps","searchButton":"RestaurantSearch_searchButton__IfR1a"};